/**
 * Set editor mode
 * @type {string}
 */
export const SET_EDITOR_MODE = 'program/SET_EDITOR_MODE';

/**
 * Fetch API - Get program data
 * @type {string}
 */
export const FETCH_PROGRAM_DATA_REQUEST = 'program/FETCH_PROGRAM_DATA_REQUEST';
export const FETCH_PROGRAM_DATA_SUCCESS = 'program/FETCH_PROGRAM_DATA_SUCCESS';
export const FETCH_PROGRAM_DATA_FAILURE = 'program/FETCH_PROGRAM_DATA_FAILURE';

/**
 * Show error modal
 * @type {string}
 */
export const SHOW_ERROR = 'program/SHOW_ERROR';

/**
 * Fetch API - Get broadcast data
 * @type {string}
 */
export const FETCH_BROADCAST_DATA_REQUEST = 'program/FETCH_BROADCAST_DATA_REQUEST';
export const FETCH_BROADCAST_DATA_SUCCESS = 'program/FETCH_BROADCAST_DATA_SUCCESS';
export const FETCH_BROADCAST_DATA_FAILURE = 'program/FETCH_BROADCAST_DATA_FAILURE';


/**
 * Fetch API - Get content library
 * @type {string}
 */
export const FETCH_CONTENT_LIBRARY_REQUEST = 'program/FETCH_CONTENT_LIBRARY_REQUEST';
export const FETCH_CONTENT_LIBRARY_SUCCESS = 'program/FETCH_CONTENT_LIBRARY_SUCCESS';
export const FETCH_CONTENT_LIBRARY_FAILURE = 'program/FETCH_CONTENT_LIBRARY_FAILURE';

/**
 * API - Save program
 * @type {string}
 */
export const SAVE_PROGRAM_REQUEST = 'program/SAVE_PROGRAM_REQUEST';
export const SAVE_PROGRAM_SUCCESS = 'program/SAVE_PROGRAM_SUCCESS';
export const SAVE_PROGRAM_FAILURE = 'program/SAVE_PROGRAM_FAILURE';

/**
 * API - Save broadcast
 * @type {string}
 */
export const SAVE_BROADCAST_REQUEST = 'program/SAVE_BROADCAST_REQUEST';
export const SAVE_BROADCAST_SUCCESS = 'program/SAVE_BROADCAST_SUCCESS';
export const SAVE_BROADCAST_FAILURE = 'program/SAVE_BROADCAST_FAILURE';


/**
 * Fetch API - Get event data
 * @type {string}
 */
export const FETCH_EVENT_DATA_REQUEST = 'program/FETCH_EVENT_DATA_REQUEST';
export const FETCH_EVENT_DATA_SUCCESS = 'program/FETCH_EVENT_DATA_SUCCESS';
export const FETCH_EVENT_DATA_FAILURE = 'program/FETCH_EVENT_DATA_FAILURE';

/**
 * API - Create new event
 * @type {string}
 */
export const CREATE_EVENT_REQUEST = 'program/CREATE_EVENT_REQUEST';
export const CREATE_EVENT_SUCCESS = 'program/CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILURE = 'program/CREATE_EVENT_FAILURE';

/**
 * API - Delete event
 * @type {string}
 */
export const DELETE_EVENT_REQUEST = 'program/DELETE_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'program/DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'program/DELETE_EVENT_FAILURE';

/**
 * API - Update event
 * @type {string}
 */
export const UPDATE_EVENT_REQUEST = 'program/UPDATE_EVENT_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'program/UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'program/UPDATE_EVENT_FAILURE';

/**
 * Process data - Include: Drop, Delete...
 * @type {string}
 */
export const PROCESS_DATA_REQUEST = 'program/PROCESS_DATA_REQUEST';
export const PROCESS_DATA_SUCCESS = 'program/PROCESS_DATA_SUCCESS';
export const PROCESS_DATA_FAILURE = 'program/PROCESS_DATA_FAILURE';

/**
 * Update workspace data when state is changed (delete, drop, ...)
 * @type {string}
 */
export const UPDATE_WORKSPACE_DATA = 'program/UPDATE_WORKSPACE_DATA';

/**
 * Handle remove node
 * @type {string}
 */
export const HANDLE_REMOVE_REQUEST = 'program/HANDLE_REMOVE_REQUEST';
export const HANDLE_REMOVE_SUCCESS = 'program/HANDLE_REMOVE_SUCCESS';
export const HANDLE_REMOVE_FAILURE = 'program/HANDLE_REMOVE_FAILURE';

/**
 * Handle drop
 * @type {string}
 */
export const HANDLE_DROP_REQUEST = 'program/HANDLE_DROP_REQUEST';
export const HANDLE_DROP_SUCCESS = 'program/HANDLE_DROP_SUCCESS';
export const HANDLE_DROP_FAILURE = 'program/HANDLE_DROP_FAILURE';

/**
 * Handle select
 * @type {string}
 */
export const HANDLE_SELECT = 'program/HANDLE_CLICK';

/**
 * Handle view zoom
 * @type {string}
 */
export const INCREMENT_VIEW_ZOOM = 'program/INCREMENT_VIEW_ZOOM';
export const DECREMENT_VIEW_ZOOM = 'program/DECREMENT_VIEW_ZOOM';

/**
 * Handle dragging
 * @type {string}
 */
export const ENABLE_IS_DRAGGING = 'program/ENABLE_IS_DRAGGING';
export const DISABLE_IS_DRAGGING = 'program/DISABLE_IS_DRAGGING';

/**
 * Handle undo & redo
 * @type {string}
 */
export const SAVE_WORK_STATE = 'program/SAVE_WORK_STATE';
export const UNDO_REQUEST = 'program/UNDO_REQUEST';
export const UNDO_WORK_STATE = 'program/UNDO_WORK_STATE';
export const REDO_REQUEST = 'program/REDO_REQUEST';
export const REDO_WORK_STATE = 'program/REDO_WORK_STATE';

/**
 * Handle change Contextual Box properties
 * @type {string}
 */
export const HANDLE_CHANGE_PROPERTIES = 'program/HANDLE_CHANGE_PROPERTIES';

/**
 * Reset currentNodeSelected
 * @type {string}
 */
export const RESET_CURRENT_NODE_SELECTED = 'program/RESET_CURRENT_NODE_SELECTED';

/**
 * Toggle modals (open | close)
 * @type {string}
 */
export const TOGGLE_EVENT_MODAL = 'program/TOGGLE_EVENT_MODAL';
export const TOGGLE_ERROR_MODAL = 'program/TOGGLE_ERROR_MODAL';
export const TOGGLE_CHOOSE_EVENT_MODAL = 'program/TOGGLE_CHOOSE_EVENT_MODAL';
export const TOGGLE_PREVIEW_MODAL = 'program/TOGGLE_PREVIEW_MODAL';

/**
 * Toggle dragging
 * @type {string}
 */
export const TOGGLE_DRAGGING = 'program/TOGGLE_DRAGGING';

/**
 * Search box
 * @type {string}
 */
export const HANDLE_CHANGE_SEARCH = 'program/HANDLE_CHANGE_SEARCH';
export const SEARCH_CONTENT_REQUEST = 'program/SEARCH_CONTENT_REQUEST';
export const SEARCH_CONTENT_SUCCESS = 'program/SEARCH_CONTENT_SUCCESS';
export const SEARCH_CONTENT_FAILURE = 'program/SEARCH_CONTENT_FAILURE';

/**
 * Update content detail
 * @type {string}
 */
export const UPDATE_CONTENT_REQUEST = 'program/UPDATE_CONTENT_REQUEST';
export const UPDATE_CONTENT_SUCCESS = 'program/UPDATE_CONTENT_SUCCESS';
export const UPDATE_CONTENT_FAILURE = 'program/UPDATE_CONTENT_FAILURE';

/**
 * Update status (NORMAL, OUT_OF_DATE, UP_TO_DATE) of single content in workspace data
 * @type {string}
 */
export const UPDATE_EVENTS_DATA = 'program/UPDATE_EVENTS_DATA';

/**
 * Fetch API - Get desktop player data
 * @type {string}
 */
export const FETCH_DESKTOP_PLAYER_REQUEST = 'program/FETCH_DESKTOP_PLAYER_REQUEST';
export const FETCH_DESKTOP_PLAYER_SUCCESS = 'program/FETCH_DESKTOP_PLAYER_SUCCESS';
export const FETCH_DESKTOP_PLAYER_FAILURE = 'program/FETCH_DESKTOP_PLAYER_FAILURE';

/**
 * Toggle event collapse
 * @type {string}
 */
export const TOGGLE_EVENT_COLLAPSE = 'program/TOGGLE_EVENT_COLLAPSE';

/**
 * Fetch API - Get list segments
 * @type {string}
 */
export const FETCH_AUDIENCES_REQUEST = 'program/FETCH_AUDIENCES_REQUEST';
export const FETCH_AUDIENCES_SUCCESS = 'program/FETCH_AUDIENCES_SUCCESS';
export const FETCH_AUDIENCES_FAILURE = 'program/FETCH_AUDIENCES_FAILURE';

/**
 * Fetch API - Get list automated broadcast
 * @type {string}
 */
export const FETCH_AUTOMATED_BROADCAST_REQUEST = 'program/FETCH_AUTOMATED_BROADCAST_REQUEST';
export const FETCH_AUTOMATED_BROADCAST_SUCCESS = 'program/FETCH_AUTOMATED_BROADCAST_SUCCESS';
export const FETCH_AUTOMATED_BROADCAST_FAILURE = 'program/FETCH_AUTOMATED_BROADCAST_FAILURE';

/**
 * Fetch API - Get tenant settings
 * @type {string}
 */
export const FETCH_TENANT_SETTINGS_REQUEST = 'program/FETCH_TENANT_SETTINGS_REQUEST';
export const FETCH_TENANT_SETTINGS_SUCCESS = 'program/FETCH_TENANT_SETTINGS_SUCCESS';
export const FETCH_TENANT_SETTINGS_FAILURE = 'program/FETCH_TENANT_SETTINGS_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/program/constants.js